import {
  LandingPageReferralSourceConsumerGenericFragment,
  LandingPageReferralSourceConsumerToExpertFragment,
  LandingPageReferralSourceExpertDirectFragment,
  ReferralExpertFragment,
  RefereeFragment,
  ReferralCodeFragment
} from '#src/generated/graphql'
import config from '#src/config'
import qs from 'qs'

enum ReferralMedium {
  Link = 'link',
  Facebook = 'fb',
  Email = 'email'
}

interface SellableShareProps {
  entryPoint: Tracking.EntryPoint
  departmentSlug: string
  referrerId: string
  sellableId: string
  sellableTitle: string
}

export function createSellableShareUrl(props: SellableShareProps) {
  const consumer = config.get('consumer')
  const { departmentSlug, referrerId, entryPoint } = props

  const utm_source = 'referral'
  const utm_campaign = `${departmentSlug}-referrals`
  const entry_point = entryPoint
  const { sellableId, sellableTitle } = props
  const utm_id = sellableId
  const utm_content = sellableTitle
  const path = `/sellable/${sellableId}`
  const utm_adgroup = 'consumer-sharing-sellable'

  const params = qs.stringify({
    utm_source,
    utm_adgroup,
    utm_campaign,
    utm_content,
    utm_id,
    entry_point,
    referrer_id: referrerId
  })

  const urlBase = `${consumer.protocol}://${consumer.host}${path}?${params}`

  return {
    linkShareUrl: `${urlBase}&utm_medium=${ReferralMedium.Link}`,
    fbShareUrl: `${urlBase}&utm_medium=${ReferralMedium.Facebook}`,
    emailShareUrl: `${urlBase}&utm_medium=${ReferralMedium.Email}`
  }
}

export function generateReferAFriendUrl({
  source,
  expert
}: {
  source: Tracking.EntryPoint
  expert?: string
}) {
  const params = qs.stringify({ source, expert })
  return `/refer-a-friend?${params}`
}

export const getExpertsAndRefereeFromReferralSource = (
  referralSource:
    | LandingPageReferralSourceConsumerGenericFragment
    | LandingPageReferralSourceConsumerToExpertFragment
    | LandingPageReferralSourceExpertDirectFragment
) => {
  let experts: ReferralExpertFragment[] = []
  let expertToRefer: ReferralExpertFragment | null = null
  let referee: RefereeFragment | null = null

  switch (referralSource.__typename) {
    case 'ReferralSourceConsumerGeneric':
      experts = referralSource.expertsToRefer
      referee = referralSource.user
      break
    case 'ReferralSourceConsumerToExpert':
      experts = [referralSource.referredToExpert]
      referee = referralSource.user
      expertToRefer = referralSource.referredToExpert
      break
    case 'ReferralSourceExpertDirect':
      experts = [referralSource.referredByExpert]
      expertToRefer = referralSource.referredByExpert
  }
  return { experts, referee, expertToRefer }
}

export const getPreferredReferralCodeFromPreferredExpert = (
  referralCodes: Array<ReferralCodeFragment>,
  preferredExpertId?: string | null
) => {
  let preferredReferralCode: ReferralCodeFragment | null = null
  if (!preferredExpertId) {
    return null
  }
  referralCodes.forEach(referralCode => {
    if (referralCode.source.__typename === 'ReferralSourceConsumerToExpert') {
      if (referralCode.source.referredToExpert.id === preferredExpertId) {
        preferredReferralCode = referralCode
      }
    }
  })

  return preferredReferralCode
}
